import { Controller } from "@hotwired/stimulus";
import {
  GiftCheckoutDraft,
  readGiftCheckoutDraft,
  saveGiftCheckoutDraft,
} from "./stores/gift_checkout_store";

const FIELD_MAP: Record<string, string> = {
  "payment[payable_type]": "payable_type",
  "payment[gift_attributes][giftcard_type]": "giftcard_type",
  "payment[gift_attributes][delivery_type]": "delivery_type",
  "gift_recipient[recipient_name]": "recipient_name",
  "gift_recipient[recipient_email]": "recipient_email",
  "gift_recipient[message]": "message",
  "gift_recipient[delivery_schedule]": "delivery_schedule",
  "gift_recipient[delivery_date]": "delivery_date",
  generic: "generic",
  subscription: "subscription",
};

export default class extends Controller<HTMLFormElement> {
  static values = {
    payableId: String,
    requireDelivery: String,
    fallbackUrl: String,
  };

  declare payableIdValue: string;
  declare requireDeliveryValue: string;
  declare fallbackUrlValue: string;
  declare hasPayableIdValue: boolean;
  declare hasRequireDeliveryValue: boolean;
  declare hasFallbackUrlValue: boolean;

  connect(): void {
    const draft = readGiftCheckoutDraft();

    if (
      this.hasRequireDeliveryValue &&
      draft.delivery_type !== this.requireDeliveryValue
    ) {
      if (this.hasFallbackUrlValue)
        window.location.assign(this.fallbackUrlValue);
      return;
    }

    this.prefill(draft);
  }

  save(): void {
    const attributes: GiftCheckoutDraft = {};
    const data = new FormData(this.element);

    Object.entries(FIELD_MAP).forEach(([field, key]) => {
      const value = data.get(field);
      if (typeof value === "string" && value.length > 0)
        attributes[key] = value;
    });

    if (this.hasPayableIdValue && this.payableIdValue)
      attributes.payable_id = this.payableIdValue;

    if (attributes.delivery_schedule === "send now") {
      attributes.delivery_date = todayIso();
      attributes.delivery_status = "pending";
    } else if (attributes.delivery_schedule === "send later") {
      attributes.delivery_status = "pending";
    }

    saveGiftCheckoutDraft(attributes);
  }

  prefill(draft: GiftCheckoutDraft): void {
    this.element
      .querySelectorAll<HTMLInputElement | HTMLTextAreaElement>(
        "input[name], textarea[name]"
      )
      .forEach((input) => {
        const key = FIELD_MAP[input.name];
        if (!key || draft[key] == null || input.type === "hidden") return;

        if (input instanceof HTMLInputElement && input.type === "radio") {
          input.checked = input.value === draft[key];
          if (input.checked)
            input.dispatchEvent(new Event("change", { bubbles: true }));
          return;
        }

        input.value = draft[key];
      });
  }
}

function todayIso(): string {
  const now = new Date();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${now.getFullYear()}-${month}-${day}`;
}
